<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="当前处理人:">
                            <el-input type="text" placeholder="请选择处理人" disabled v-model="currentHandlerName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getCurrentHandler } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9">
                        <el-form-item label="日期:">
                            <el-date-picker
                                v-model="createTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="primary" @click="loadData">查询</el-button>
                            <el-button type="primary" @click="reset">重置</el-button>
                            <el-button type="primary" @click="dialogVisibleEvent">邮件通知</el-button>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
        </el-card>
        <el-card>
            <el-table :data="tableData" v-loading="loading" id="personStatis">
                <el-table-column label="编号" prop="serial_number"align="center" fixed>
                   <template slot-scope="scope">
                       <!-- <el-button type="text" @click="dialogVisibleEvent(scope.row)">邮件通知</el-button> -->
                       <el-button type="text" class="hoverBtn" @click="goDetail(scope.row)">{{scope.row.serial_number}}</el-button>
                   </template>

                </el-table-column>
                <el-table-column label="当前处理人" prop="current_handler_name" align="center">
                </el-table-column>
                <el-table-column label="状态" prop="status" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column label="请求人" prop="requester" align="center"></el-table-column>
                <el-table-column label="标题" prop="title" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="create_time" align="center">
                </el-table-column>
                <el-table-column label="计划完成时间" prop="end_time" align="center">
                </el-table-column>
                <el-table-column label="项目" prop="project_name" align="center">
                </el-table-column>


                <!-- <el-table-column label="操作" width="140">
                   <template slot-scope="scope">
                       <el-button type="text" @click="dialogVisibleEvent(scope.row)">邮件通知</el-button>
                   </template>
                </el-table-column> -->
            </el-table>
        </el-card>
        <el-dialog title="发送邮件通知" :visible.sync="dialogVisible" width="50%">
          <el-form :model="dialogForm" class="search-form">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="抄送人">
                            <el-input type="text" placeholder="请选择抄送人" disabled v-model="ccName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: {moreSelect:true, callback:getCcPeople } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon ml10"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">

                    </el-col>

                </el-row>
              <el-form-item>
                  <el-button type="default" size="small" @click="dialogReset">重置</el-button>
                  <el-button type="primary" size="small" @click="sentSubmit" :disabled = "sentBtnFlag">发送</el-button>
              </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import services from "./notCompletedStatis.service";
    import Config from "../../../app.config";
    export default {
        data() {
            return {
                form:{
                    current_handler:"",
                    start_date:'',
                    end_date:'',
                },
                createTime:[],
                currentHandlerName:'',//当前处理人
                dialogForm:{
                    current_handler:"",
                    cc_users:"",
                    start_date:'',
                    end_date:'',
                },
                ccName:'',//弹窗抄送人
                tableData:[],
                loading:true,
                dialogVisible:false,
                sentBtnFlag:false,
            }
        },
        created() {
            this.request();
        },
        computed:{

        },
        methods: {
            //弹窗事件
            dialogVisibleEvent(){
                this.dialogVisible = true
                this.dialogForm={
                    current_handler:this.form.current_handler,
                    start_date:this.createTime[0],
                    end_date:this.createTime[1],
                }

            },
            //选择的处理人
            getCurrentHandler(obj){
                // console.log(obj,'选择指派人[0]');
                this.currentHandlerName=obj.name
                this.form={
                    ...this.form,
                    current_handler:obj.internalUserid
                }
            },
            //弹窗的抄送人
            getCcPeople(obj){
                let itmName=[]
                let itmId = []
                if(obj.length>0){
                    obj.map(item=>{
                        itmName.push(item.name)
                        itmId.push(item.internalUserid)
                    })
                }
                this.ccName=itmName.join(',')
                this.dialogForm={
                    ...this.dialogForm,
                    cc_users:itmId
                }
            },
            //跳转详情
            goDetail(row){
                // console.log(row)
                //Eve  事件 ，Pro 问题，Cha 变更，Dep 发布
                let routerurl = ''
                switch(row.category) {
                     case "Eve":
                        routerurl = '/eventDetail'
                        break;
                     case "Pro":
                       routerurl = '/problemDetail'
                        break;
                     case "Cha":
                        routerurl = '/changeDetail'
                        break;
                     case "Dep":
                        routerurl = '/deployDetail'
                        break;
                }
                // this.onCancel()
                let routeUrl = this.$router.resolve({
                 path: routerurl,
                 query: {
                   serialNumber:row.serial_number
                 }
               });
               window.open(routeUrl.href, '_blank');
                // this.$router.push({
                //   path: routerurl,
                //   query: {
                //     serialNumber:row.serial_number
                //   }
                // })

            },
            dialogReset(){
                this.dialogForm={
                    current_handler:"",
                    cc_users:"",
                    start_date:'',
                    end_date:'',
                }
                this.ccName=''//弹窗抄送人
            },
            loadData(){
                this.loading = true;
                this.form={
                    ...this.form,
                    start_date: this.createTime[0],
                    end_date:this.createTime[1]
                }
                this.request();
            },
            //重置
            reset(){
                this.form={
                    current_handler:"",
                    start_date:'',
                    end_date:'',
                }
                this.currentHandlerName = ''
                this.createTime=[]
            },
            request(){
                // 获取列表数据
                // this.tableData = [];
                services.getNocompletedList(this.form).then(res => {
                    this.tableData = res;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            sentSubmit(){
                this.dialogForm = {
                    ...this.dialogForm
                }
                this.sentBtnFlag = true
                // console.log(this.dialogForm)
                services.sendmsg(this.dialogForm).then(res => {
                    this.$message.success("发送成功");
                    this.dialogReset()
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.request();
                    this.sentBtnFlag = false
                    this.dialogVisible = false
                })
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.hoverBtn{
    :hover{
        // font-size:18px;
    }
    padding:10px 30px;

}
.titleColod{
    color:#0099FF;
}
p{
    line-height: 20px;
}
</style>
